
import {
  FaBell, FaCalendarCheck, FaUserShield, FaChartPie,
  FaMobileAlt, FaCloudUploadAlt
} from "react-icons/fa";

const features = [
  {
    icon: <FaBell />,
    title: "Smart Notifications",
    desc: "Automated alerts for warranty expiry, maintenance due dates, low stock, and overdue work orders — all on your dashboard."
  },
  {
    icon: <FaCalendarCheck />,
    title: "Automated Scheduling",
    desc: "Set maintenance frequency (weekly to yearly) with a start date. The system automatically calculates and tracks every due date."
  },
  {
    icon: <FaUserShield />,
    title: "Secure Role-Based Access",
    desc: "JWT authentication with separate portals for operators, technicians, and managers. Each role sees only what they need."
  },
  {
    icon: <FaChartPie />,
    title: "Visual Analytics",
    desc: "Interactive pie charts, bar graphs, area trends, and KPI cards for instant comprehension of asset health and costs."
  },
  {
    icon: <FaMobileAlt />,
    title: "Responsive Design",
    desc: "Fully responsive interface that works seamlessly on desktops, tablets, and mobile devices for on-the-go asset management."
  },
  {
    icon: <FaCloudUploadAlt />,
    title: "Document Management",
    desc: "Attach invoices, manuals, and photos directly to asset records. Preview and manage purchase documentation easily."
  }
];

const FeaturesSection = () => {
  return (
    <section id="features" className="lp-features">
      <div className="lp-features__inner">
        <div className="lp-section-header">
          <span className="lp-section-tag">Key Features</span>
          <h2>Everything You Need, Easy to Use</h2>
          <p>
            Built to save time, reduce errors, and give your team full
            visibility into every asset you manage.
          </p>
        </div>

        <div className="lp-features__grid">
          {features.map((f, i) => (
            <div className="lp-features__card" key={i}>
              <div className="lp-features__icon">{f.icon}</div>
              <div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
